export function removeNullUndefinedFields<T>(obj: {
    [key: string]: any
}, includeZero: boolean = false, nonClearFields?: string[]): T {
    const result: { [key: string]: T } = {};

    for (const key in obj) {
        if ((obj[key] !== null && obj[key] !== undefined && obj[key] !== '' && (includeZero || obj[key] !== 0))
            || nonClearFields?.includes(key)) {
            result[key] = obj[key];
        }
    }

    return result as T;
}

export function removeNullUndefinedSpecificKeyFieldsRecursive<T>(obj: {
    [key: string]: any
}, clearFields: string[]): T {
    const result: Record<string, any> = {};

    for (const key in obj) {
        if (Array.isArray(obj[key])) {
            result[key] = obj[key].map((nestObj: any) => removeNullUndefinedSpecificKeyFieldsRecursive(nestObj, clearFields));
        } else if ((obj[key] !== null && obj[key] !== undefined && obj[key] !== '' && obj[key] !== 0
            && clearFields?.includes(key)) || !clearFields?.includes(key)) {
            result[key] = obj[key];
        }
    }

    return result as T;
}
